import Component from '@ember/component';
import { action, get, set } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { v4 } from 'ember-uuid';

/* attrs
  - item
  - editing
*/
export default Component.extend({
  editing: false,

  didReceiveAttrs() {
    this._super(...arguments);
    let item = this.item;
    if (isEmpty(get(item, 'id'))) {
      set(item, 'id', v4());
    }
  },

  toggleEditing: action(function () {
    this.toggleProperty('editing');
  }),
});
